<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <div>
      <button nbButton ghost (click)="cancel()" status="primary">
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>

      <button
        [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'info' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('info')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        Thông tin
      </button>

      <button
        [ngClass]="menu == 'detail' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'detail' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('detail')"
      >
        <nb-icon class="button-icon" icon="file-text-outline"></nb-icon>
        Chi tiết
      </button>

      <button
        *ngIf="user.admin || user.moderator || user.finance"
        [ngClass]="menu == 'receipt' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'receipt' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('receipt')"
      >
        <nb-icon class="button-icon" icon="calendar-outline"></nb-icon>
        Công nợ
      </button>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="menu == 'info'">
    <p class="lorem text-danger description">
      {{ errMessages }}
    </p>

    <div class="row">
      <div class="col-12 col-sm-5">
        <ngx-view-customer
          [customer]="customer"
          [mode]="'crm'"
          (onEdit)="onEditCustomer($event)"
          class="card-item"
        ></ngx-view-customer>

        <form [formGroup]="taskForm" class="form-inline bg-white">
          <nb-form-field fullWidth>
            <nb-icon nbPrefix icon="hash-outline"></nb-icon>

            <textarea
              nbInput
              fullWidth
              class="form-control"
              placeholder="Nhập tên công việc"
              rows="5"
              id="title"
              [(ngModel)]="workingTask.title"
              formControlName="title"
              #title
            ></textarea>

            <button
              nbSuffix
              type="submit"
              nbButton
              status="primary"
              [disabled]="submitted || !taskForm.valid"
              [class.btn-pulse]="submitted"
              (click)="create()"
            >
              <nb-icon icon="save-outline"></nb-icon>
            </button>
          </nb-form-field>
        </form>
      </div>

      <div class="col-12 col-sm-7" [nbSpinner]="loading" nbSpinnerStatus="info">
        <div class="form-inline bg-white">
          <ngx-view-time-period
            (periodChange)="selectTime($event)"
            [typeSelected]="'thisMonth'"
          ></ngx-view-time-period>

          <ngx-view-selection-object
            *ngIf="user.moderator"
            [shopId]="shopId"
            [objectType]="'user'"
            [objectId]="assignBy"
            [objectName]="assignName"
            [objects]="users"
            (objectChange)="objectChange($event)"
          >
          </ngx-view-selection-object>

          <nb-form-field fullWidth>
            <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              [(ngModel)]="strSearch"
              (change)="onSearch()"
            />
            <span nbSuffix class="text-hint">({{ display.length }})</span>
          </nb-form-field>
        </div>

        <div class="crews">
          <nb-list>
            <nb-list-item
              class="contact"
              *ngFor="
                let task of display
                  | paginate
                    : { itemsPerPage: itemsPerPage, currentPage: page };
                let i = index
              "
            >
              <ngx-view-working-task-card
                [workingTask]="task"
                (click)="viewTaskDetail(task)"
                class="card-item"
                [mode]="'customer'"
              ></ngx-view-working-task-card>
            </nb-list-item>

            <nb-list-item>
              <pagination-controls
                (pageChange)="pageChange($event)"
              ></pagination-controls>
            </nb-list-item>
          </nb-list>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-body *ngIf="menu == 'detail'">
    <ngx-view-gallery
      *ngIf="customer.sourceType == 'images' && customer.imagesUrl.length > 0"
      [imagesUrl]="customer.imagesUrl"
    >
    </ngx-view-gallery>

    <ngx-view-video
      *ngIf="customer.sourceType == 'video' && customer.videoUrl != ''"
      [url]="customer.videoUrl"
    ></ngx-view-video>

    <ngx-view-document
      *ngIf="customer.sourceType == 'document' && customer.content != ''"
      [content]="customer.content"
    >
    </ngx-view-document>
  </nb-card-body>

  <nb-card-footer> </nb-card-footer>
</nb-card>
